import { useClient } from '@composables/use-clients';
import { useTenantStore } from '@stores/tenant-store';
import { urls } from '@api/urls';
import { TenantType } from '@api/types';
import {
  DeleteRequestArgsType,
  PutRequestArgsType,
} from '@api/v1/types';
import { withTryCatch } from '@api/v1/error-handlers';

export type PutTenantPayloadType = (
  Pick<TenantType, 'name' | 'description'>
);

export const apiFetchTenant = async ({
  domain = useTenantStore().domain,
  errorConfig = {},
  callbacks = {},
} = {}) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.get({ url: urls.v1.tenant({ domain }) });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};

export const apiUpdateTenant = async ({
  payload,
  domain = useTenantStore().domain,
  errorConfig = {},
  callbacks = {},
}: PutRequestArgsType<PutTenantPayloadType>) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.put({
      url: urls.v1.tenant({ domain }),
      payload,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};

export const apiDeleteTenant = async ({
  domain = useTenantStore().domain,
  errorConfig = {},
  callbacks = {},
}: DeleteRequestArgsType = {}) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.delete({
      url: urls.v1.tenant({ domain }),
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
